import {
  Alignment,
  Autoformat,
  Bold,
  DecoupledEditor,
  Essentials,
  FontSize,
  Indent,
  IndentBlock,
  Italic,
  List,
  Paragraph,
  PasteFromOffice,
  RemoveFormat,
  Table,
  TableEditing,
  TableProperties,
  TableToolbar,
  TableUI,
  Underline,
} from 'ckeditor5';

import 'ckeditor5/ckeditor5.css';

class HeadlessEditor extends DecoupledEditor {}

HeadlessEditor.builtinPlugins = [
  Alignment,
  Autoformat,
  Bold,
  FontSize,
  Essentials,
  Indent,
  IndentBlock,
  Italic,
  List,
  Paragraph,
  PasteFromOffice,
  RemoveFormat,
  Table,
  TableToolbar,
  TableProperties,
  TableUI,
  TableEditing,
  Underline,
];

// Editor configuration.
HeadlessEditor.defaultConfig = {
  licenseKey: 'GPL',
  table: {
    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
    tableProperties: {
      defaultProperties: {
        borderStyle: 'dashed',
        borderColor: 'hsl(0, 0%, 90%)',
        borderWidth: '3px',
        alignment: 'left',
      },
    },
  },

  fontSize: {
    options: [10, 12, 14, 16, 18, 20, 22],
    supportAllValues: true,
  },
  language: 'en',
};

export default HeadlessEditor;
